import axiosConfig from './axiosConfig';
import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from './queryClient';

// List notifications
export const getNotificationList = async (queryParams = {}) => {
    try {
        const response = await axiosConfig.get('notifications', { params: queryParams });
        return response;
    } catch (error) {
        throw error;
    }
};

// Get notification statistics
export const getNotificationStats = async () => {
    try {
        const response = await axiosConfig.get('notifications/stats');
        return response;
    } catch (error) {
        throw error;
    }
};

// Mark all notifications as read
export const markAllNotificationsRead = async () => {
    try {
        const response = await axiosConfig.post('notifications/mark-all-read');
        return response;
    } catch (error) {
        throw error;
    }
};

// Show notification details
export const getNotificationDetail = async (id) => {
    try {
        const response = await axiosConfig.get(`notifications/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Delete notification
export const deleteNotification = async (id) => {
    try {
        const response = await axiosConfig.delete(`notifications/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Mark notification as read
export const markNotificationRead = async (id) => {
    try {
        const response = await axiosConfig.post(`notifications/${id}/read`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const useNotifications = (page, options = {}) => useQuery({
    queryKey: ['notifications', page],
    queryFn: () => getNotificationList({ page }).then(response => response.data),
    keepPreviousData: true,
    staleTime: 1000 * 60,
    retry: 1,
    ...options,
});

export const useMarkNotificationRead = (options = {}) => {
    return useMutation({
        mutationFn: (notifId) => markNotificationRead(notifId),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'] }),
        retry: 1,
        ...options,
    });
};

export const useMarkAllNotificationsRead = (options = {}) => {
    return useMutation({
        mutationFn: () => markAllNotificationsRead(),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'] }),
        retry: 1,
        ...options,
    });
};

//OneSignal related api

export const LOCAL_PLAYER_ID_KEY = 'playerId';

// Store or update a OneSignal player id for the authenticated user
export const savePlayerId = async ({ player_id, device_type }) => {
    try {
        const response = await axiosConfig.post('/onesignal/player', { player_id, device_type });
        return response;
    } catch (error) {
        throw error;
    }
};

// Remove a OneSignal player id for the authenticated user
export const deletePlayerId = async () => {
    let playerId = localStorage.getItem(LOCAL_PLAYER_ID_KEY);
    localStorage.removeItem(LOCAL_PLAYER_ID_KEY);
    if (!playerId) return;

    try {
        const response = await axiosConfig.delete(`/onesignal/player/${playerId}`);
        return response;
    } catch (error) {
        throw error;
    }
};